import { useLatest } from "@/hooks/useLatest";
import { CanvasData } from "../types/canvasTypes";
import { findViewportObjectInFabricJson } from "../utils/canvasUtils";
import { selectCurrentCanvasData } from "@/store/templateEditor/templateEditorSelectors";
import { useSelector } from "react-redux";
import { parseViewportSize } from "../utils/viewportUtils";

const DEFAULT_VIEWPORT_SIZE = "1920x1080";

export function useTemplateViewportSize() {
  const currentCanvasData = useSelector(selectCurrentCanvasData);
  const viewportSize = getViewportSize(currentCanvasData);
  const viewportSettingsRef = useLatest(parseViewportSize(viewportSize));

  return {
    viewportSize,
    viewportSettingsRef,
  };
}

const getViewportSize = (canvasData?: CanvasData) => {
  if (!canvasData) return DEFAULT_VIEWPORT_SIZE;
  const viewportObject = findViewportObjectInFabricJson(canvasData);
  if (!viewportObject) return DEFAULT_VIEWPORT_SIZE;
  return `${viewportObject.width}x${viewportObject.height}`;
};
